import AdminCrons from './container';

export default AdminCrons;
